module.exports = __webpack_public_path__ + "img/3.88fc9fee.jpg";